import { Box, Button, Card, Container, Typography } from "@mui/material";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import moment from "moment";
import api from "../../../components/services/api"
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import mime from "mime";
import { saveAs } from "file-saver";

export default function ShipCostReport() {
    const [dateStart, setDateStart] = useState(null);
    const [dateEnd, setDateEnd] = useState(null);
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState("");
    const[data, setData] = useState([])
    
    const columns = [
        { field: "InvoiceNo", headerName: "Invoice No.", width: 150 },
        { field: "BillTo", headerName: "Bill To", width: 200 },
        { field: "VoyOut", headerName: "Voy No.", width: 100 },
        // {
        //  field: "ETD", headerName: "ETD", width: 150,
        // },
        { field: "Tug", headerName: "Tug", width: 100 },

        { field: "Barge", headerName: "Barge", width: 200 },
        // { field: "QuotationNo", headerName: "Quotation No", width: 150 },
        // { field: "SaleOrderNo", headerName: "SaleOrderNo No", width: 150 },
        { field: "AgentName", headerName: "Agent Name", width: 200 },
        { field: "ServiceDescription", headerName: "Service Description", width: 200 },
        { field: "TotalTHB", headerName: "Total (THB)", width: 200, renderCell: (value) => {
            return parseFloat(value?.row?.Total, 10).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        }},
    ];
 
    
  
    const search1 = async ()=>{
      const params = new URLSearchParams();
      if (dateStart)
        params.append("sdate", moment(dateStart).format("yyyy-MM-DD"));
      if (dateEnd) params.append("edate", moment(dateEnd).format("yyyy-MM-DD"));
      const data = await  api.get(`api/report/ShipCost/list?${params}`)
  
      const result = data?.data.map((x, i) => ({
        ...x,
        id: i + 1
    }))
      
      setData(result)
    }
  
  
    const getdata = async () => {
      const data = await api.get(`api/report/ShipCost/list`);
  
      const result = data?.data.map((x, i) => ({
        ...x,
        id: i + 1
    }))
  
      setData(result);
    };
  
    useEffect(() => {
      getdata();
    }, []);
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
        รายงานต้นทุน
        </h6>
        <h3 style={{ marginTop: "10px" }} className="textcolordarkblue">
        Ship Cost
        </h3>
        <div
          style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}
        >
          {/* <TextField
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            size="small"
            id="outlined-basic"
            label="Search Voy"
            variant="outlined"
          /> */}

          <DesktopDatePicker
            label="Date Start"
            value={dateStart}
            onChange={ (newValue) => {
              setDateStart(moment(newValue).format('yyyy-MM-DD'));
              
            }}
            inputFormat="yyyy/MM/dd"
            minDate={new Date("2017-01-01")}
            renderInput={(params) => (
              <TextField
                size="small"
                style={{ width: "200px", marginLeft: "10px" }}
                {...params}
              />
            )}
          />
          <DesktopDatePicker
            label="Date End"
            value={dateEnd}
            inputFormat="yyyy/MM/dd"
            onChange={ (newValue) => {
              setDateEnd(moment(newValue).format('yyyy-MM-DD'));
              
            }}
            minDate={new Date(dateStart)}
            renderInput={(params) => (
              <TextField
                size="small"
                style={{ width: "200px", marginLeft: "10px" }}
                {...params}
              />
            )}
          />
          <Button
            style={{
              backgroundColor: "#0d6efd",
              color: "#fafafa",
              marginLeft: "10px",
            }}
            onClick={search1}
          >
            <SearchIcon />
          </Button>
          <Button
                variant="contained"
                style={{ textTransform: "none", backgroundColor: "#007BFF", marginLeft: "10px"  }}
                onClick={async () => {
                  setLoading(true)
                  const params = new URLSearchParams();
                  if (dateStart)
                    params.append("sdate", moment(dateStart).format("yyyy-MM-DD"));
                  if (dateEnd) params.append("edate", moment(dateEnd).format("yyyy-MM-DD"));
                  await api.get(`api/report/ShipCost/download/excel?${params}`, {
                    responseType: "blob",
                    timeout: 30000
                  })
                    .then((blobFile) => {
                      const blobFileRes = new File([blobFile?.data], "test.xlsx", {
                        type: mime.getType(".xlsx"),
  
                      });
  
                      // window.open(
                      //   URL.createObjectURL(blobFileRes, "test.csv"),
                      //   "_blank"
                      // );
                      saveAs(blobFileRes, "ReportShipCost.xlsx");
                      setLoading(false)
                    });
  
                }}>
                Download
              </Button>
        </div>
        <Box sx={{height:'700px',marginTop:'25px'}}>
        <DataGrid
            getRowId={(r) => r.id}
            rows={data}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            hideFooterSelectedRowCount
            disableColumnFilter
            disableColumnMenu
            
          />
        </Box>
      </Card>
    </LocalizationProvider>
  )
}
